import Header from "./header/Header";
import ListPart from "./listpart/ListPart";
import LinkPart from "./linkpart/LinkPart";
import Footer from "./footer/Footer";
import SectionContextProvider from "../contexts/sectionContext";
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import hasPermission from "/src/utils/hasPermission";
import "./Sidebar.css";
import storage from "/src/utils/storage";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import storage from "/src/utils/storage";
import checkPelletByTime from "/src/utils/checkPelletByTime"
//import useCompany from "/src/hooks/useCompany";

function SideBar() {
    // needed to reload sidebar
    useAuthStateContext();

    const user = storage("local").get("user");
    var bots = [{ name: "View more", url: urlWithRoutingCompany("bots/list") }];

    var datasets = [{ name: "View more", url: urlWithRoutingCompany("datasets/list") }];

    var dashboards = [{ name: "View more", url: urlWithRoutingCompany("dashboards/list") }];

    const sortList = (data) => {
        return data.sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at);
        });
    };

    const services = [
        hasPermission("view_integrations")
            ? { name: "API & MCP Integration", url: urlWithRoutingCompany("plugin/integrations/list") }
            : null,
        hasPermission("view_channels")
            ? { name: "channels", url: urlWithRoutingCompany("plugin/channels/list") }
            : null,
        hasPermission("view_migrations")
            ? { name: "duplicate", url: urlWithRoutingCompany("plugin/migrations/list") }
            : null,
    ].filter((category) => category);

    const ai = [
        //hasPermission("view_integrations") ? { name: "llm", url: urlWithRoutingCompany("ai/llm/list") } : null,
        hasPermission("view_integrations") ? { name: "brains", url: urlWithRoutingCompany("ai/llm-rag/list") } : null,
        /*
        hasPermission("view_integrations")
            ? { name: "threads", url: urlWithRoutingCompany("ai/llm-rag/chat/history") }
            : null,
            */
    ].filter((category) => category);

    const supervision = [
        hasPermission("view_analytics")
            ? { name: "analytics", url: urlWithRoutingCompany("supervision/analytics/list") }
            : null,
        hasPermission("view_conversations")
            ? { name: "conversations", url: urlWithRoutingCompany("supervision/conversations/list") }
            : null,
        hasPermission("view_conversations")
            ? { name: "opt-outs", url: urlWithRoutingCompany("supervision/optouts/list") }
            : null,
        hasPermission("view_conversations")
            ? { name: "withheld destinations", url: urlWithRoutingCompany("supervision/withheld-destinations/list") }
            : null,
    ].filter((category) => category);

    const admin = [
        hasPermission("view_organizations") || hasPermission("view_users") || hasPermission("view_roles") || hasPermission("view_phones")
            ? { name: "configuration", url: "/administration/configuration" }
            : null,
        hasPermission("view_telephony_logs") ? { name: "telephony logs", url: "/administration/telephony/logs" } : null,
    ].filter((category) => category);

    const sidebarRefEvents = (el) => {
        if (!el) {
            return;
        }
        el.addEventListener("mouseenter", () => (el.className = "sidebar visible transition"));
        el.addEventListener("mouseleave", () => (el.className = "sidebar reduced transition"));
    };

    const hasPelletIn = (list) => {
        if (list == null) return "";
        const hasOne = list.some(row => checkPelletByTime(row, 2 * 24 * 60 * 60 * 1000));
        return hasOne
    }

    const company = storage("session").get("company");
    var company_name = "";
    var nb_bots = 0;
    var nb_datasets = 0;
    var nb_dashboards = 0;
    if (company) {
        let listBotsSorted = sortList(company.bots);
        let listDatasetsSorted = sortList(company.datasets);
        let listDashboardsSorted = sortList(company.dashboards);

        bots = [
            ...(hasPermission("update_bot")
                ? listBotsSorted
                    .slice(0, 3)
                    .map((bot) => ({ name: bot.name, url: urlWithRoutingCompany(`bots/${bot.name}`) }))
                : []),
            ...bots,
        ];
        
        datasets = [
            ...(hasPermission("update_dataset")
                ? listDatasetsSorted.slice(0, 3).map((dataset) => {
                    return { name: dataset.name, url: urlWithRoutingCompany("datasets/" + dataset.name) };
                })
                : []),
            ...datasets,
        ];
        dashboards = [
            ...(hasPermission("update_dashboard")
                ? listDashboardsSorted.slice(0, 3).map((dashboardChannel) => {
                    return {
                        name: dashboardChannel.name ? dashboardChannel.name : dashboardChannel.dashboard.name,
                        url: urlWithRoutingCompany(
                            "dashboard/editor" +
                            (dashboardChannel.company_id != company.id ? "/view/" : "/") +
                            dashboardChannel.id
                        ),
                    };
                })
                : []),
            ...dashboards,
        ];
        company_name = company.name;
        nb_bots = company.bots.length;
        nb_datasets = company.datasets.length;
        nb_dashboards = company.dashboards.length;
    }
    //useCompany(user.company_id);

    return (
        <div id="sidebar-container">
            <div id="sidebar" className="sidebar reduced transition" ref={sidebarRefEvents}>
                <Header />
                <div id="container">
                    <SectionContextProvider>
                        {hasPermission("view_home") ? (
                            <LinkPart url={urlWithRoutingCompany("home")} name="home" label={company_name} />
                        ) : null}
                        { /* hasPermission("view_ais") ? <ListPart data={ai} name="ai" plural={false} /> : null */}
                        { hasPermission("view_bots") ? <LinkPart url={urlWithRoutingCompany("/bots/list")} name="bot" plural={true} numberOfData={nb_bots}/> : null }
                        { hasPermission("view_bots") ? <LinkPart url={urlWithRoutingCompany("/bot-profiles")} name="botprofil" label="Bot Profiles"/> : null }
                        {/*hasPermission("view_bots") ? <ListPart data={bots} name="bot" numberOfData={nb_bots} pelletStyle={hasPelletIn(company?.bots) ? "green_pastille_sidebar" : ""} /> : null*/}
                        {/*hasPermission("view_datasets") ? ( <ListPart data={datasets} name="dataset" label="dataset"numberOfData={nb_datasets}svgName="dataset" />) : null */}
                        { hasPermission("view_datasets") ? <LinkPart url={urlWithRoutingCompany("/datasets/list")} name="dataset" plural={true} numberOfData={nb_datasets}/> : null }

                        { hasPermission("view_ais") ? <LinkPart url={urlWithRoutingCompany("ai/llm-rag/list")} name="ai" label={"brain"} plural={true}/> : null }

                        { /*hasPermission("view_ais") ? <ListPart data={ai} name="ai" plural={false} /> : null*/ }
                        { hasPermission("view_dashboards") ? <LinkPart url={urlWithRoutingCompany("/dashboards/list")} name="dashboard" plural={true} numberOfData={nb_dashboards}/> : null }
                        { /*hasPermission("view_dashboards") ? ( <ListPart data={dashboards}name="dashboard" label="dashboard" numberOfData={nb_dashboards}/>) : null */}
                        {services.length ? <ListPart data={services} name="plugin" /> : null}
                        {supervision.length ? <ListPart data={supervision} name="supervision" plural={false} /> : null}
                        {admin.length ? <ListPart data={admin} name="admin" plural={false} /> : null}
                        <LinkPart url={urlWithRoutingCompany("memos")} name="memos" />
                        <LinkPart url="/user/settings/" name="settings" />
                        <LinkPart externalLink="https://www.talkr.ai/fr/template/" name="help"/>
                    </SectionContextProvider>

                </div>
                <Footer />
            </div>
        </div>
    );
}

export default SideBar;
